const data = [
     { 
        id: 1, 
        name: 'Documento de identificação (RG, CNH, CPF)',
    },
    { 
        id: 2, 
        name: 'Documento de procuração',
    },
    { 
        id: 3, 
        name: 'Comprovante de pagamento (pix, boleto ou cartão de crédito)',
    },
    { 
        id: 4, 
        name: 'Cópia integral do processo judicial',
    },
    { 
        id: 5, 
        name: 'Documento que indique o número do processo ajuizado',
    },
    { 
        id: 6, 
        name: 'Certidão de habilitação de crédito e/ou sentença e certidão de trânsito em julgado',
    },
    { 
        id: 7, 
        name: 'Contrato(s)',
    },
    { 
        id: 8, 
        name: 'Nota(s) fiscal(is) com aceite',
    },
    { 
        id: 9, 
        name: 'Cópia integral da CTPS',
    },
    { 
        id: 10, 
        name: 'Termo de rescisão do contrato de trabalho',
    },
    { 
        id: 11, 
        name: 'Extrato atualizado do FGTS',
    },
    { 
        id: 12, 
        name: 'Comprovação da prestação dos serviços',
    },
    { 
        id: 13, 
        name: 'Relação de títulos oferecidos em garantia',
    },
    { 
        id: 50, 
        name: 'Outro',
    },


];

export default [...data];